<div class="materia">
    <h4 class="mat-h2">{{materia.nombreCompleto}}</h4>
    <div class="materiaContenido mat-elevation-z2">
        <div class="materiaInfo">
            <div class="profesores">
                <ng-container *ngFor="let profesor of materia.profesores">
                    <div class="profesor">
                        <p class="profesor__nombre">{{profesor.nombresApellidos}}
                            <small class="profesor__otros">{{profesor.eMail}}</small>
                        </p>
                    </div>
                </ng-container>
            </div>
            <span class="spacer"></span>
            <div>
                <ul class="flex-wrap">
                    <li *ngIf="materia.informePdfUrl">
                        <a target="_blank" href="{{materia.informePdfUrl}}">
                            <button mat-button color="primary">Informes</button>
                        </a>
                    </li>
                    <!-- 
                    <li>
                        <a [routerLink]="['/', 'estudio', 'familia', 'alumno', hijoID, 'nivelaciones']" fragment="mat-{{materia.id}}">
                            <button mat-button color="primary">Nivelaciones</button>
                        </a>
                    </li>
                     -->
                </ul>
            </div>
        </div>
        <div class="materiasDetalle">
            <mat-list>
                <h3 mat-subheader *ngIf="materia.unidades.length > 0; else sinUnidades">
                    Unidades
                </h3>
                <ng-template #sinUnidades>
                    <h3 mat-subheader>Sin unidades publicadas</h3>
                </ng-template>
                <mat-list-item *ngFor="let unidad of materia.unidades">
                    <a [routerLink]="['/', 'estudio', 'familia', 'alumno', hijoID, 'unidad', unidad.id]">{{unidad.nombre}}</a>
                    <!-- <button mat-button (click)="openDialog(unidad.id)">Profile</button> -->
                </mat-list-item>
            </mat-list>
        </div>
    </div>
</div>
